import {
  Dialog,
  DialogActions,
  DialogContent,
  DialogTitle,
} from "@mui/material";
import axios from "axios";
import {
  FormLabel,
  ModalError,
  ModalSuccess,
  NumberInput,
  PrimaryButton,
  SecondaryButton,
} from "components";
import { useEffect, useState } from "react";
import { hardBaseUrl } from "services/urlConstant";
import { getErrors } from "utils";

const ModalDefaultTresshold = ({ open, onClose, getDataTable }) => {
  const token = localStorage.getItem("token");
  const headers = {
    Authorization: `Bearer ${token}`,
  };

  const [loadingButton, setLoadingButton] = useState(false);
  const [tresshold, setTresshold] = useState(0);

  const getDetail = async () => {
    try {
      setLoadingButton(true);
      const res = await axios.get(
        `${hardBaseUrl}/publisher/cost-allocation/tresshold`,
        { headers }
      );
      setTresshold(res?.data?.data?.tresshold);
    } catch (error) {
      ModalError(getErrors(error?.response));
    } finally {
      setLoadingButton(false);
    }
  };

  const handleSubmit = async () => {
    try {
      setLoadingButton(true);
      await axios.post(
        `${hardBaseUrl}/publisher/cost-allocation/tresshold`,
        { tresshold },
        { headers }
      );
      ModalSuccess("Tresshold has been updated successfully").then(() =>
        getDataTable()
      );
    } catch (error) {
      ModalError(getErrors(error?.response));
    } finally {
      setLoadingButton(false);
    }
  };

  useEffect(() => {
    getDetail();
  }, []);

  return (
    <Dialog fullWidth open={open} onClose={!loadingButton && onClose}>
      <DialogTitle>Default Treshold</DialogTitle>
      <DialogContent dividers>
        <FormLabel label="Tresshold" required />
        <NumberInput
          value={tresshold}
          onChange={value => setTresshold(Number(value))}
          endAdornment="%"
          disabled={loadingButton}
        />
      </DialogContent>
      <DialogActions>
        <SecondaryButton label="Cancel" onClick={onClose} />
        <PrimaryButton
          label={loadingButton ? "Saving..." : "Save"}
          loading={loadingButton}
          disabled={loadingButton}
          onClick={handleSubmit}
        />
      </DialogActions>
    </Dialog>
  );
};

export default ModalDefaultTresshold;
